/**
 * @flow
 * @relayHash 8a830da0203980fe74773ca1de26fea9
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ActivateReleaseInput = {|
  id: string,
  clientMutationId?: ?string,
|};
export type ActivateReleaseMutationVariables = {|
  input: ActivateReleaseInput
|};
export type ActivateReleaseMutationResponse = {|
  +activateRelease: ?{|
    +updatedRelease: ?{|
      +id: string,
      +isActive: boolean,
    |}
  |}
|};
export type ActivateReleaseMutation = {|
  variables: ActivateReleaseMutationVariables,
  response: ActivateReleaseMutationResponse,
|};
*/


/*
mutation ActivateReleaseMutation(
  $input: ActivateReleaseInput!
) {
  activateRelease(input: $input) {
    updatedRelease {
      id
      isActive
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ActivateReleaseInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "activateRelease",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ActivateReleasePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updatedRelease",
        "storageKey": null,
        "args": null,
        "concreteType": "ReleaseNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isActive",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ActivateReleaseMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ActivateReleaseMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "ActivateReleaseMutation",
    "id": null,
    "text": "mutation ActivateReleaseMutation(\n  $input: ActivateReleaseInput!\n) {\n  activateRelease(input: $input) {\n    updatedRelease {\n      id\n      isActive\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '54cf777805c3dd6819673cce0292323a';
module.exports = node;
